// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import type { Element, Node } from 'react';
import { Helmet } from 'react-helmet';
import staticRoutes from './client/routes';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import InlineSVG from 'react-inlinesvg';
import get from 'lodash.get';
import NotFound from 'NotFound';
import loadHeader from 'App/client/external/header';
import ViewportDetector from 'Common/ViewportDetector';
import { shouldRedirect, buildRedirectUrl } from 'Common/redirect';
import { Footer, Header } from 'Common/Olympus';
import { Grid, Row, Col } from 'Common/Grid';
import styles from 'components/App.scss';
import getClassifiedsSite from 'utils/getClassifiedsSite';

import AddSearchClient from 'addsearch-js-client';

import * as Actions from 'actionTypes';

const SEARCH_SITE_KEY = '0ea08de063eac91cddb58f6ba6eac1b6';
const AUTOCAR = 'autocar';

const redirectOrComponent = (props, route) => {
  const match = props.match;
  const url = match.url;

  return shouldRedirect(match) ? (
    <Redirect to={buildRedirectUrl(url)} />
  ) : (
    // $FlowFixMe
    <route.component {...props} exact={route.exact} routes={route.routes} />
  );
};

redirectOrComponent.propTypes = {
  match: PropTypes.object
};

// $FlowFixMe
export const RouteWithSubRoutes = (route): Node => {
  return (
    <Route
      path={route.path}
      render={props => redirectOrComponent(props, route)}
    />
  );
};

/**
 * <App /> component.
 */
class App extends Component<*, *> {
  addSearchClient: Object;
  addSearchUI: Object;

  /**
   *  App constructor.
   *  @param {object} props to constructor.
   *  @constructor
   */
  constructor(props: Object) {
    super(props);
    this.state = {
      addSearchUI: {},
      ready: false
    };

    this.addSearchClient = new AddSearchClient(SEARCH_SITE_KEY);
  }

  /**
   * MapStateToProps implementation.
   * @return {object} new state object
   * @param {object} state object
   */
  static mapStateToProps(state: Object): Object {
    return {
      viewport: state.viewport
    };
  }

  /* eslint-disable camelcase */
  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;
    dispatch({
      type: Actions.FETCH_POSTCODE
    });
  }

  /**
   * componentDidMount().
   *
   * @returns {void}
   */
  componentDidMount() {
    const { dispatch } = this.props;
    loadHeader();

    if (typeof this.addSearchUI === 'undefined') {
      const AddSearchUI = require('addsearch-search-ui');
      this.addSearchUI = new AddSearchUI(this.addSearchClient);
    }

    this.setState({
      ready: true
    });

    dispatch({
      type: Actions.FETCH_SHORTLIST
    });
  }

  /**
   * Renders the App component.
   *
   * @return {JSX} - renders the root component with a header and footer.
   */
  render(): Element<*> {
    const viewportSize = get(this.props, ['viewport', 'viewport']);
    const { ready } = this.state;
    const { PUBLIC_URL, BASE_URL, NEW_CAR_URL } = process.env;

    const searchStyle = ready ? styles.searchOn : styles.search;
    const routes = staticRoutes.map((route, i) => (
      <RouteWithSubRoutes key={i} {...route} />
    ));

    const publicUrl = PUBLIC_URL || '';
    const classifiedsSite = getClassifiedsSite();
    const hideHeaderFooter = classifiedsSite && classifiedsSite === AUTOCAR;

    return (
      <div className={searchStyle}>
        <Helmet>
          <title>What Car? - Classifieds</title>
        </Helmet>
        <ViewportDetector />
        {!hideHeaderFooter && viewportSize && (
          <Header
            addSearchClient={this.addSearchClient}
            addSearchUI={this.addSearchUI}
            viewport={viewportSize === 'xs' ? viewportSize : 'lg'}
            whatCarUrl={`${BASE_URL || ''}`}
            newCbeUrl={`${String(NEW_CAR_URL || '')}`}
          />
        )}
        <Switch>
          {routes}
          <Route component={NotFound} />
        </Switch>
        <InlineSVG
          src={`${publicUrl}/svg/icons.svg`}
          uniquifyIDs={false}
          onLoad={src => {
            console.log('svg sprite loaded');
          }}
          className={styles.displayNone}
        />
        {!hideHeaderFooter && viewportSize && (
          <div className={styles.footerContainer}>
            <Grid>
              <Row>
                <Col colXs={12}>
                  <Footer
                    whatCarUrl={`${BASE_URL || ''}`}
                    viewport={viewportSize}
                  />
                </Col>
              </Row>
            </Grid>
          </div>
        )}
      </div>
    );
  }
}

export { App };
// $FlowFixMe
export default withRouter(connect(App.mapStateToProps, null, null)(App));



// WEBPACK FOOTER //
// ./src/App/index.js